import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PublicCommunityDataObject } from 'models/service';

type GetCommunityPublicRouteParams = { id: string };

export const getCommunityPublic = async ({ routeParams: { id } }: RouteParamsRequest<GetCommunityPublicRouteParams>) =>
  apiClient.get<PublicCommunityDataObject, ApiClientResponse<PublicCommunityDataObject>>(
    routes.community.getPublic(id),
  );
